<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Gran Arkidians"></no-habilitado>
    <div style="margin-top:80px; text-align:center">
      <h1>Tus arkidians</h1>

      <div v-if="arkidians.length>0" class="row" style="justify-content: center; display:block;">
        <div class="container">
          <div class="row" style="justify-content: center">
            <app-arkidian-complete
              v-for="(arkidian,index) in arkidians"
              :arkidian="arkidian"
              v-bind:key="index"
            ></app-arkidian-complete>

            <div class="card card-arkidian" style="cursor: pointer" @click="nuevoArkidian()">
              <div style="padding:20px">
                <h3>Crear Arkidian</h3>
                <img
                  src="public/images/arkidians/nuevo.svg"
                  style="width:200px"
                  class="card-img-top"
                  alt="Nuevo arkidian"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ArkidianComplete from "../arkidian/ArkidianComplete";
import Loader from "../shared/Loader";
import NoHabilitado from "../shared/NoHabilitado";

export default {
  name: "admArkdian",
  data() {
    return {
      arkidians: [],
      habilitado: false,
    };
  },
  methods: {
    nuevoArkidian() {
      this.$router.push({ path: "/NuevoArkidian" });
    },
    buscarArkidians() {
      var self = this;

      fetch(self.pathAPI + "hijos.php?usuario_padre=" + self.userLogged.user)
        .then(response => response.json())
        .then(data => {
          console.log(data)
          self.arkidians = data;
        });
    }
  },
  computed: {
    ...mapGetters([
      "pathAPI",
      "userLogged",
      "categorias",
      "cursoSeleccionado",
      "categoriaSeleccionada"
    ])
  },
  components: {
    appArkidianComplete: ArkidianComplete,
    Loader: Loader,
    NoHabilitado: NoHabilitado
  },

  mounted: function() {
    if (this.userLogged.profile == "PADRE") {
      this.habilitado = true;
      this.buscarArkidians();
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>

<style scoped>
.card-arkidian {
  border-radius: 15px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
  background-color: #ececec;
}

.card-arkidian:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

@media screen and (max-width: 600px) {
  .card-arkidian {
    width: 250px;
    margin: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/sections/ArkidiansAdmin.vue